module.exports = __webpack_public_path__ + "7f8af60e6c7c7f5325458935cfa7ed4a.svg";